
































































import { Component } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';

// Component
import ElementBgIcon from '@/components/elements/ElementBgIcon.vue';

@Component({
  components: {
    ElementBgIcon,
  },
})
export default class DialogUpdateInformations extends MixinDialog {
  currentSlide = 0;
  slides = [
    {
      id: 'global',
      img: {
        id: 'YJPljiv23RvFw3KW0vsJVMxQ.6TBrlna',
        name: 'fireworks.svg',
        size: 110,
      },
    },
    {
      id: 'patient-file',
      img: {
        id: 'ndrj9fCiVoLvg5Oty5cImDShpujrYe_O',
        name: 'pathology.svg',
        size: 140,
      },
    },
    {
      id: 'analysis',
      img: {
        id: 'aqzKD.V5kPXgvZM.gkHRxpAPrV_T3NkC',
        name: 'pain-level.svg',
        size: 180,
      },
    },
    {
      id: 'security',
      img: {
        id: 'wgyqIF6MGvk60WR0dunkFd2KwmNWcbyl',
        name: 'security.svg',
        size: 160,
      },
    },
  ];

  get doctor() {
    return this.$pdc.doctor!.current;
  }

  get version() {
    return this.$pdc.update!.version;
  }

  get versionSplitted() {
    return this.version?.split('.');
  }

  get versionSimple() {
    return this.$pdc.update!.toSimple(this.versionSplitted);
  }

  get isLastSlide() {
    return this.currentSlide < this.slides.length - 1;
  }

  get versionLocalStorage(): string | null {
    return this.$pdc.storage!.getUniversal('version');
  }
  set versionLocalStorage(value: string | null) {
    this.$pdc.storage!.setUniversal('version', value);
  }

  nextPage() {
    if (this.currentSlide < this.slides.length - 1) {
      this.currentSlide++;
    } else {
      this.closeDialog();
    }
  }
  closeDialog() {
    this.versionLocalStorage = this.version;
    this.dialog = false;
  }

  mounted() {
    if (
      this.$pdc.update!.toSimple(this.version.split('.')) !==
      this.$pdc.update!.toSimple(this.versionLocalStorage?.split('.'))
    ) {
      if (
        !Object.prototype.hasOwnProperty.call(this.doctor, 'hasKit') ||
        !this.$pdc.update!.currentVersionNeedToDisplayDialog
      ) {
        this.versionLocalStorage = this.version;
      } else {
        this.dialog = true;
      }
    }
  }
}
